import { render, staticRenderFns } from "./shuxing.vue?vue&type=template&id=ab3384c2&scoped=true&"
import script from "./shuxing.vue?vue&type=script&lang=js&"
export * from "./shuxing.vue?vue&type=script&lang=js&"
import style0 from "./shuxing.vue?vue&type=style&index=0&id=ab3384c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3384c2",
  null
  
)

export default component.exports